import { useQuery, UseQueryResult } from "@tanstack/react-query";
import type { Budget } from "model";

import { api } from "~utils";

type useBudgetsType = (args: {
  showSuperadminBudgets: boolean;
  hideInactive?: boolean;
  includeSpend?: boolean;
}) => UseQueryResult<Budget[]>;

export const useBudgets: useBudgetsType = ({
  showSuperadminBudgets,
  hideInactive = true,
  includeSpend = false,
}) => {
  return useQuery<Budget[]>({
    queryKey: ["budgets", { hideInactive }],
    queryFn: async () => {
      const { data } = await api({
        url: `/api/admin/budget?hideInactive=${hideInactive}&includeSpend=${includeSpend}`,
      });
      return data || [];
    },
    select: (data: Budget[]) => {
      if (!showSuperadminBudgets) {
        return data.filter((budget: Budget) => !budget.hideFromAdmin) || [];
      }
      return data;
    },
  });
};
